export const compareNaturalText = (a: string, b: string): number =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: "accent" });
